export function normalizeSmbBasePathInput(value?: string | null) {
  const normalized = (value ?? "").trim().replace(/\\/g, "/");
  if (!normalized) {
    return "/";
  }
  if (!normalized.startsWith("/")) {
    return normalized;
  }
  return normalized.length > 1 ? normalized.replace(/\/+$/g, "") : normalized;
}
